import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  BoxExpand,
  Button,
  ICONS,
  PLATFORM_THEME_COLORS,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';

import { UserInfoEdit } from './components/user-info-edit';
import { UserInfoView } from './components/user-info-view';

const UserInfo = ({ data }: { data: any }) => {
  const { t } = useTranslation('common');
  const [isEdit, setIsEdit] = useState(false);

  return (
    <BoxExpand
      title={t('labels.userProfile')}
      separator
      titleFontSize={TYPOGRAPHY_SIZE.medium}
      buttons={
        !isEdit && (
          <Button
            type="primary"
            ghost
            icon={ICONS.editAlt}
            iconColor={PLATFORM_THEME_COLORS.primary.blue}
            onClick={() => setIsEdit(true)}
          >
            {t('buttons.edit')}
          </Button>
        )
      }
    >
      {isEdit ? (
        <UserInfoEdit data={data} onCancel={() => setIsEdit(false)} />
      ) : (
        <UserInfoView data={data} />
      )}
    </BoxExpand>
  );
};

export default UserInfo;
